import clsx from "clsx";
import { FC } from "react";
import InfoIcon from "../InfoIcon";

interface OfferTextProps {
  color?: "info" | "purple";
  text: string;
  value: string;
  stacked?: boolean;
  info?: string;
}
const OfferText: FC<OfferTextProps> = ({
  text,
  value,
  color,
  stacked,
  info,
}) => {
  return (
    <div
      className={clsx("flex items-start text-app-body-2", {
        "flex-col l:flex-row l:justify-between": stacked,
        "justify-between": !stacked,
      })}
    >
      <span className="text-opacity-60 text-neutral-675 flex items-center">
        {text}
        {info && (
          <span className="ml-xs">
            <InfoIcon>{info}</InfoIcon>
          </span>
        )}
        :
      </span>
      <span
        className={clsx("whitespace-nowrap px-xs -mx-xs rounded-xs", {
          "bg-purple-50 text-purple-725": color === "purple",
          "bg-info-50 text-info-700": color === "info",
        })}
      >
        {value}
      </span>
    </div>
  );
};

export default OfferText;
